import {
  ROUTE_INSTITUTION_EDIT,
  ROUTE_INSTITUTION_UNIT,
  ROUTE_INSTITUTIONS,
  ROUTE_KINDERGARTENS_BROWSER,
} from 'config/routes';
import React, { FC, useContext, Fragment } from 'react';
import { Route, Routes } from 'react-router-dom';
import { relativePath } from 'utils/navigation/relativePath';
import { NotFoundView } from 'views/Errors/NotFound.view';
import { InstitutionEdit } from './InstitutionEdit/InstitutionEdit.view';
import { InstitutionsList } from './InstitutionsList/InstitutionsList.view';
import { Unit } from 'views/Panel/Institutions/Unit/Unit.view';
import { Breadcrumb } from 'components/shared/navigation/Breadcrumbs/Breadcrumb';
import { LocaleContext } from 'context/locale';

export const InstitutionsView: FC = () => {
  const { trans } = useContext(LocaleContext);

  return (
    <Fragment>
      <Breadcrumb label={trans('BREADCRUMB.UNITS.INSTITUTIONS')} static />
      <Breadcrumb label={trans('BREADCRUMB.UNITS.INSTITUTIONS-LIST')} to={ROUTE_INSTITUTIONS} />

      <Routes>
        <Route path={relativePath(ROUTE_INSTITUTIONS, ROUTE_INSTITUTIONS)} element={<InstitutionsList />} />
        <Route path={relativePath(ROUTE_INSTITUTION_EDIT, ROUTE_INSTITUTIONS)} element={<InstitutionEdit />} />
        <Route path={relativePath(`${ROUTE_INSTITUTION_UNIT}/*`, ROUTE_INSTITUTIONS)} element={<Unit />} />
        <Route path={relativePath(ROUTE_KINDERGARTENS_BROWSER, ROUTE_INSTITUTIONS)} element={<span>kindergartens</span>} />
        <Route path="*" element={<NotFoundView />} />
      </Routes>
    </Fragment>
  );
};
